import { Tokens } from '../types';

// getTokensFromNewMicrosoftSignIn() is used to get the Access Token and Refresh Token from a new Microsoft sign in without signing the user out of their current session
// the function takes no parameters
// The function is async and needs to be called with await
// The function returns a 'Tokens' object containging the access and refresh token if successful or 'null' if unsuccessful
// e.g. const userId = await getUserIDFromNewMicrosoftSignIn();
export async function getTokensFromNewMicrosoftSignIn(): Promise<Tokens | null> {
  //get client id from environment variables
  const clientIdResponse: Response = await fetch(
    '/api/getEnv/getMicrosoftClientId'
  );
  const { clientId } = await clientIdResponse.json();

  return new Promise((resolve) => {
    try {
      // Response Type
      const RESPONSE_TYPE = 'code';

      // Page to redirect to with code
      const REDIRECT_URI = `${window.origin}/auth/postEventMicrosoftTokensCallback`;

      // Response Mode
      const RESPONSE_MODE = 'query';

      // Scope | what do we want access to
      const SCOPE =
        'offline_access Calendars.ReadWrite Contacts.Read User.Read';

      // Random number for "state" parameter
      const randomState: string = Math.floor(Math.random() * 99999).toString();

      // Promt to force user to pick account
      const PROMT = 'select_account';

      // Create url parameters
      const params = new URLSearchParams({
        client_id: clientId,
        response_type: RESPONSE_TYPE,
        redirect_uri: REDIRECT_URI,
        response_mode: RESPONSE_MODE,
        scope: SCOPE,
        state: randomState,
        prompt: PROMT,
      });

      // Open new window to microsoft login page
      const url = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${params.toString()}`;

      window.open(url, 'Connect Account', 'width=600,height=800');

      // Listen for event containing access tokens
      window.addEventListener('message', (e) => {
        // Check if event came from the window we opened
        if (e.origin !== window.origin) return resolve(null);

        // 'e.data' is either equal to null or a 'Tokens' object, redundant if statement used to explicitly set the type to either 'Tokens' or 'null'
        if (e.data) {
          return resolve(e.data as Tokens);
        } else {
          return resolve(null);
        }
      });
    } catch (error: unknown) {
      // Specify where error came from, return null
      console.error('src/utils/auth0/getUserIDFromNewMicrosoftSignIn', error);
      return resolve(null);
    }
  });
}
